import { atom } from "jotai";

export const isDocumentBodyScrollLockedAtom = atom(false);
